export default __webpack_public_path__ + "static/building-f53cbeaae3ea9977ed1eedf5dd6e0b9b.jpg";